import { sendPiUserValue } from '@rei/sscid-listener'

export default class GpcUtils {
  static createAndSendGpcPayload(billingAddressData) {
    const { address } = billingAddressData;
    const customerDetails = {
      firstName: address.firstName,
      lastName: address.lastName,
      email: address.email,
      phone: address.phoneNumber,
      address: {
        address1: address.line1,
        address2: address.line2,
        city: address.city,
        state: address.stateCode,
        zipCode: address.postalCode,
        countryCode: address.countryCode,
      },
    };

    // Send information along to the end point
    const payload = {
      appnamespace: 'REI_WEB_SSCID',
      customerDetails,
    };
    sendPiUserValue(payload).catch((e) => {
      console.log(e);
    });
  }
}
